import React, { createContext, useContext, useState, useEffect } from "react";
import { translations } from "./translations";

const LanguageContext = createContext();

export const useLanguage = () => {
    const context = useContext(LanguageContext);
    if (!context) {
        throw new Error("useLanguage must be used within a LanguageProvider");
    }
    return context;
};

export const LanguageProvider = ({ children }) => {
    // Try to get language from localStorage, default to 'vi'
    const [language, setLanguage] = useState(() => {
        return localStorage.getItem("app_language") || "vi";
    });

    useEffect(() => {
        localStorage.setItem("app_language", language);
    }, [language]);

    const t = (key) => {
        const dict = translations[language];
        return dict[key] || key; // Return key if translation needed
    };

    const toggleLanguage = () => {
        setLanguage((prev) => (prev === "vi" ? "en" : "vi"));
    };

    return (
        <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t }}>
            {children}
        </LanguageContext.Provider>
    );
};
